import styled from 'styled-components';

import { Center } from 'legacyComponents/styled/lib';
import { ViewWrapper } from 'libs/rendering/styles';
import Button from 'components/Button';

export const ButtonStyled = styled(Button)`
  &:hover {
    box-shadow: 0 1px 1px rgba(44, 45, 48, 0.07);
  }
`;

export const PreviewCard = styled.div`
  position: relative;
  border: 1px solid ${props => props.theme.color.wfGrey300};
  box-shadow: 0 1px 1px rgba(44, 45, 48, 0.07);
  margin: 0px;
  overflow: hidden;
  background-color: ${props => props.theme.color.wfWhite};
  display: flex;
  flex-direction: column;
  height: ${props => `${props.outputHeight}px` || 'auto'};
  min-height: ${props => (props.editorMode ? 'auto' : '8rem')};

  > video > p {
    margin: 0px;
  }
  > img {
    display: block;
  }
  .overlay {
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 1;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0);
    transition: opacity 0.25s linear;
  }
  .preview-element {
    width: 100%;
  }
  &:hover .overlay {
    opacity: 1;
  }
`;

export const FallbackText = styled.p`
  text-align: center;
  line-height: 1.4;
  padding: 10px;
  margin: 0px;
  font-size: 0.75em;
  font-style: italic;
`;

export const WIPpreviewer = styled(Center)`
  height: 100%;
  ${ViewWrapper} {
    background: none;
  }
  background: url(/assets/checker-bg.gif) repeat top left;
`;
